import React from 'react';

interface Traveler {
  emailAddress: string;
  lateDeparture: number;
  lateArrival: number;
  cancellation: number;
  connection: number;
  diverted: number;
  total: number;
}

interface DisruptionsByTravelerProps {
  data: {
    travelers: Traveler[];
    lateDeparture: number;
    lateArrival: number;
    cancellation: number;
    connection: number;
    diverted: number;
    grandTotal: number;
  };
}

const DisruptionsByTraveler: React.FC<DisruptionsByTravelerProps> = ({ data }) => {
  return (
    <div className="col-md-12">
      <div className="table-responsive">
        <table className="table table-striped table-hover report-table">
          <thead>
            <tr>
              <th className="header">Email Address</th>
              <th className="header">Late Departures</th>
              <th className="header">Late Arrivals</th>
              <th className="header">Cancellations</th>
              <th className="header">Connections</th>
              <th className="header">Diverted</th>
              <th className="header">Total</th>
            </tr>
          </thead>
          <tbody>
            {data.travelers.map((traveler, index) => (
              <tr key={index}>
                <td>{traveler.emailAddress}</td>
                <td>{traveler.lateDeparture}</td>
                <td>{traveler.lateArrival}</td>
                <td>{traveler.cancellation}</td>
                <td>{traveler.connection}</td>
                <td>{traveler.diverted}</td>
                <td>{traveler.total}</td>
              </tr>
            ))}
            <tr><td colSpan={7} className="grand-total"></td></tr>
            <tr>
              <td className="data-total">Grand Total</td>
              <td className="data-total">{data.lateDeparture}</td>
              <td className="data-total">{data.lateArrival}</td>
              <td className="data-total">{data.cancellation}</td>
              <td className="data-total">{data.connection}</td>
              <td className="data-total">{data.diverted}</td>
              <td className="data-total">{data.grandTotal}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DisruptionsByTraveler;